<template lang="pug">
    .conteudo
        .linha(style='margin: 0px')
            .coluna
                title-component(:label='$route.meta.titulo')

        .linha(style='margintop: 0px')
            .coluna
                breadcrumb-component(:list="tipoDocumento")


        .linha
            .coluna
                filter-basic-component(
                    @filtro:pesquisar='pesquisar({nome: $event, pagina: 1, quantidadePagina: 10})',
                )

            .coluna-2.cadastro-position
                button-component.botao-cadastrar(
                    style="width: '100%'"
                    label='Cadastrar tipo de documento',
                    icon='mdi-plus-circle-outline',
                    @click.native='openCreateModal()',
                )

        .linha
            .coluna
                TipoDocumentoTableComponent(
                    :headers='headers'
                    :data='paginacao.documento'
                    :paginacao='paginacao'
                    :is-loading='isLoading'
                    @table:page-changed='checkPaginationChange'
                    @action:edit='editDocument'
                    @action:delete='deleteDocument'
                    @action:inactivate='inactivateDocument'
                )

                EditarDocumentoModal(
                v-if="isModalVisible"
                :show="isModalVisible"
                :document='currentDocument'
                @close='closeModal'
                @update='handleUpdate'
                )
                CriacaoDocumentoModal(
                v-if="isCreateModalVisible"
                :show="isCreateModalVisible"
                @close='closeCreateModal'
                @create='handleCreate'
                )
                ConfirmaDelecaoModal(
                v-if="isDeleteModalVisible"
                :show="isDeleteModalVisible"
                :documentId="currentDocument.id"
                @close="closeDeleteModal"
                @confirm="confirmDeleteDocument"
                )

</template>
<script>
import { listarTiposDocumentosAll, editarTiposDocumentos } from '@/services/tipo-documento.service';
import TipoDocumentoTableComponent from '@/views/tipoDocumento/components/TipoDocumentoTableComponent.vue';
import EditarDocumentoModal from '@/views/tipoDocumento/components/EditarDocumentoModal.vue';
import CriacaoDocumentoModal from '@/views/tipoDocumento/components/CriacaoDocumentoModal.vue';
import ConfirmaDelecaoModal from '@/views/tipoDocumento/components/ConfirmaDelecaoModal.vue';
import { tipoDocumento } from '@/utils/breadcrumb.utils';
import FilterBasicComponent from '@/components/standard/FilterBasicComponent.vue';

export default {
    name: 'TipoDocumentoComponent',
    components: {
        TipoDocumentoTableComponent,
        EditarDocumentoModal,
        editarTiposDocumentos,
        ConfirmaDelecaoModal,
        CriacaoDocumentoModal,
        FilterBasicComponent
    },
    data() {
        return {
            headers: [
                { text: 'Nome', field: 'nome', maxWidth: '' },
                { text: 'Descrição', field: 'descricao', maxWidth: '' },
                { text: 'Ultima Alteração', field: 'dataAtualizacao', maxWidth: '' },
                { text: 'Ativo', field: 'ativo', maxWidth: '', format: value => value ? 'Sim' : 'Não' },
                { text: 'Uso', field: 'hasRelatedDocument', maxWidth: '', format: value => value ? 'Sim' : 'Não' },
                { text: 'Ações', field: 'acoes', maxWidth: '150px' }
            ],
            filtroNome: '',
            filtroAplicado: false,
            paginacao: {
                total: 0,
                pagina: 1,
                numeroPaginas: 0,
                quantidadePagina: 10,
                documento: []
            },
            isLoading: false,
            isModalVisible: false,
            currentDocument: null,
            isCreateModalVisible: false,
            isDeleteModalVisible: false,
            tipoDocumento: tipoDocumento
        };
    },

    async created() {
        this.isLoading = true;
        await this.carregarTiposDocumentos();
        this.isLoading = false;
    },
    computed: {
        breadcrumb() {
            const paginaAtual = this.$route.meta.titulo;
            return this.breadcrumbMap[paginaAtual];
        }
    },

    methods: {
        async carregarTiposDocumentos() {
            try {
                this.isLoading = true;
                const response = await listarTiposDocumentosAll();
                let documentos = response;

                if (this.filtroNome) {
                    documentos = documentos.filter(doc =>
                        doc.nome.toLowerCase().includes(this.filtroNome.toLowerCase())
                    );
                }

                // Atualiza o total de documentos e o número total de páginas
                this.paginacao.total = documentos.length;
                this.paginacao.numeroPaginas = Math.ceil(this.paginacao.total / this.paginacao.quantidadePagina);

                // Calcula o índice de início e fim dos itens da página atual
                const inicio = (this.paginacao.pagina - 1) * this.paginacao.quantidadePagina;
                const fim = Math.min(inicio + this.paginacao.quantidadePagina, this.paginacao.total);

                // Atualiza a lista de documentos exibidos na página atual
                this.paginacao.documento = documentos.slice(inicio, fim);

                // Exibe a faixa de itens para a página atual
                const faixaInicio = inicio + 1;
                const faixaFim = Math.min(fim, this.paginacao.total);
            } catch (error) {
                console.error('Erro ao carregar tipos de documentos:', error);
            } finally {
                this.isLoading = false;
            }
        },

        async pesquisar({ nome, pagina, quantidadePagina }) {
            this.filtroNome = nome;
            this.paginacao.pagina = pagina;
            this.paginacao.quantidadePagina = quantidadePagina;
            await this.carregarTiposDocumentos();
        },

        checkPaginationChange(page) {
            this.paginacao.pagina = page;
            this.carregarTiposDocumentos();
        },

        editDocument(document) {
            this.currentDocument = { ...document };
            this.isModalVisible = true;
        },

        deleteDocument(document) {
            this.currentDocument = document;
            this.isDeleteModalVisible = true;
        },
        closeDeleteModal() {
            this.isDeleteModalVisible = false;
        },
        confirmDeleteDocument() {
            this.isDeleteModalVisible = false;
            this.carregarTiposDocumentos();
        },

        async inactivateDocument(document) {
            try {
                await editarTiposDocumentos(document.id, document.nome, document.descricao, !document.ativo);
                this.carregarTiposDocumentos();
            } catch (error) {
                console.error('Erro ao alterar status do documento:', error);
            }
        },

        closeModal() {
            this.isModalVisible = false;
        },

        async handleUpdate() {
            this.carregarTiposDocumentos();
            this.closeModal();
        },

        openCreateModal() {
            this.isCreateModalVisible = true;
        },

        closeCreateModal() {
            this.isCreateModalVisible = false;
        },

        async handleCreate() {
            this.carregarTiposDocumentos();
            this.closeCreateModal();
        }
    }
};
</script>
<style lang="scss" scoped>
.conteudo {
    padding: 20px;
}

.linha {
    margin-bottom: 20px;
}

.coluna {
    display: flex;
    flex-direction: column;
}

.botao-criar {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    background-color: var(--primary-green);
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: var(--primary-green);
    }

    i {
        margin-right: 5px;
    }
}

.filtro-container {
    display: flex;
    align-items: center;

    input[type='text'] {
        margin-right: 10px;
        padding: 5px;
        border: 1px solid #ccc;
        border-radius: 4px;
        flex: 1;
    }

    button {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        background-color: var(--primary-green);
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: var(--primary-green);
        }

        i {
            margin-right: 5px;
        }
    }
}

.acao-container {
    display: flex;
    justify-content: space-between;

    button {
        margin-right: 5px;
        padding: 5px;
        background-color: var(--primary-green);
        color: var(--primary-green);
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: var(--primary-green);
        }

        i {
            margin-right: 5px;
        }
    }
}

.filtro-border {
    border: 1px solid var(--primary-green);
    background-color: var(--primary-green);
    padding: 10px;
    border-radius: 5px;
}

.cadastro-position {
    display: flex;
    justify-content: flex-end;
}

.botao-cadastrar {
    height: 32px;
}
</style>
